<template>
  <div
    class="timetable-patient-cell"
    v-bind:class="{ ignore: isDrag }"
    v-bind:draggable="isDraggable"
    v-on:click.stop="dispatchClick"
    v-on:keydown="dispatchClick"
    v-on:dragend="onDragEnd"
    v-on:dragstart="onDragStart">
    <template v-if="isOneRowLayout">
      <div class="timetable-patient-cell__row">
        <span class="timetable-patient-cell__name">
          {{ patientName }}
        </span>
        <span class="timetable-patient-cell__time">
          {{ interval }}
        </span>
      </div>
    </template>
    <default-layout
      v-else-if="isDefaultLayout"
      v-bind:age-title="ageTitle"
      v-bind:can-create-invoice="canCreateInvoice"
      v-bind:interval="interval"
      v-bind:is-initial="isInitial"
      v-bind:labels="labels"
      v-bind:patient-name="patientName"
      v-bind:status="status"
      v-bind:invoice-status="invoiceStatus"
      v-bind:has-view-patient-invoices="hasViewPatientInvoices"
      v-bind:card-number="patientCardNumber"
      v-bind:patient-birth-date="patientBirthDate"
      v-bind:date="date"
      v-bind:is-archived="archived"
      v-on:click.stop="onCreateInvoice"
    />
    <div
      class="timetable-patient-cell__hover"
      v-bind:style="{ backgroundColor: processedColor, height: processedHeight }"
      ref="cellPopupRef"
      v-if="canShowExpandedData"
    >
      <default-layout
        v-bind:age-title="ageTitle"
        v-bind:can-create-invoice="canCreateInvoice"
        v-bind:interval="interval"
        v-bind:is-initial="isInitial"
        v-bind:labels="labels"
        v-bind:patient-name="patientFullName"
        v-bind:status="status"
        v-bind:invoice-status="invoiceStatus"
        v-bind:has-view-patient-invoices="hasViewPatientInvoices"
        v-bind:card-number="patientCardNumber"
        v-bind:patient-birth-date="patientBirthDate"
        v-bind:date="date"
        v-bind:is-archived="archived"
        v-on:click.stop="onCreateInvoice"
        v-on:open-invoices="onOpenInvoices"
      />
      <section
        class="timetable-patient-cell__info"
        v-if="availableExpandedInfo"
      >
        <div
          v-for="service in expandedSlot.serviceNames"
          v-bind:key="service"
          class="timetable-patient-cell__info__text"
        >
          {{ service }}
        </div>
        <div class="timetable-patient-cell__info__note">{{ note }}</div>
        <popover-menu
          v-if="countContactsConnect > 1"
          custom-class="timetable-cell-modal-contacts"
          offset-x
          v-bind:close-on-content-click="true"
          v-model="isShowPhoneDialog"
        >
          <div class="timetable-cell-modal-contacts__content">
            <the-tooltip v-if="canInitiateCalls && noCalls" position="bottom">
              <template v-slot:trigger="{ listenerObject }">
                <button
                  class="timetable-cell-modal-contacts__button phone"
                  type="button"
                  title="Начать звонок"
                  v-on="listenerObject">Начать звонок</button>
              </template>
              Пациент отказался от звонков
            </the-tooltip>
            <button
              v-else
              class="timetable-cell-modal-contacts__button phone"
              type="button"
              title="Начать звонок"
              v-on:click.stop="onInitiateCall">Начать звонок</button>
            <the-tooltip v-if="expandedSlot.hasWhatsApp && !agreeMailing" position="bottom">
              <template v-slot:trigger="{ listenerObject }">
                <button
                  class="timetable-cell-modal-contacts__button whatsapp"
                  type="button"
                  title="Открыть чат"
                  v-on="listenerObject">Открыть Whats App чат</button>
              </template>
              Пациент отказался от рассылок
            </the-tooltip>
            <button
              v-else-if="expandedSlot.hasWhatsApp"
              class="timetable-cell-modal-contacts__button whatsapp"
              type="button"
              title="Открыть чат"
              v-on:click.stop="onOpenWhatsAppChat">Открыть Whats App чат</button>
            <the-tooltip v-if="messengersAccess && !agreeMailing" position="bottom">
              <template v-slot:trigger="{ listenerObject }">
                <button
                  class="timetable-cell-modal-contacts__button chat-push"
                  type="button"
                  title="Открыть чат"
                  v-on="listenerObject">Открыть чат в мессенджере</button>
              </template>
              Пациент отказался от рассылок
            </the-tooltip>
            <button
              v-else-if="messengersAccess"
              class="timetable-cell-modal-contacts__button chat-push"
              type="button"
              title="Открыть чат"
              v-on:click.stop="onOpenMessengersChat">Открыть чат в мессенджере</button>
          </div>
          <template v-slot:trigger="{ listenerObject }">
            <button
              type="button"
              class="timetable-patient-cell__info__text callable"
              v-on="listenerObject"
            >
              {{ expandedSlot.patientPhone }}
            </button>
          </template>
        </popover-menu>
        <the-tooltip
          v-else-if="countContactsConnect === 1 && contactConnectRestrictTitle"
          position="bottom"
        >
          <template v-slot:trigger="{ listenerObject }">
            <button
              class="timetable-patient-cell__info__text callable"
              type="button"
              v-bind:title="contactConnectTitle"
              v-on="listenerObject">{{ expandedSlot.patientPhone }}</button>
          </template>
          {{ contactConnectRestrictTitle }}
        </the-tooltip>
        <button
          v-else-if="countContactsConnect === 1"
          class="timetable-patient-cell__info__text callable"
          type="button"
          v-bind:title="contactConnectTitle"
          v-on:click.stop="onClickContact"
        >
          {{ expandedSlot.patientPhone }}
        </button>
        <div
          v-else
          class="timetable-patient-cell__info__text">{{ expandedSlot.patientPhone }}</div>
      </section>
      <section
        v-if="showLabels"
        class="timetable-patient-cell__info employee"
      >
        <div class="timetable-patient-cell__info__note">Особые отметки</div>
        <patient-labels v-bind:labels="expandedSlot.labelNames" />
      </section>
      <section
        v-if="showEmployeeName"
        class="timetable-patient-cell__info employee"
      >
        <div class="timetable-patient-cell__info__note">Врач</div>
        <div class="timetable-patient-cell__text">{{ expandedSlot.employeeName }}</div>
      </section>
    </div>
  </div>
</template>

<script>
import PatientLabels from '@/components/PatientLabels.vue';
import PopoverMenu from '@/components/PopoverMenu.vue';
import { EventBus, NAME_EVENT_OPEN_MESSENGERS_CHAT, NAME_EVENT_OPEN_WHATS_APP_CHAT } from '@/utils/eventBus';
import TheTooltip from '@/components/TheTooltip.vue';

const STATUS_ABSENT = 'absent';
const STATUS_CAME = 'came';
const STATUS_CONFIRM = 'confirm';
const STATUS_PRODOCTOROV = 'prodoctorov';

/**
 * @description Компонент статуса записи на прием.
 * @type {Vue}
 */
const appointmentStatus = {
  functional: true,
  props: {
    status: { required: true, type: String },
  },
  name: 'appointmentStatus',
  render(createElement, { props }) {
    const makeAppointmentStatusIcon = (type, title) => createElement(
      'span',
      { staticClass: 'timetable-patient-cell__status', class: type, attrs: { title } },
    );
    switch (props.status) {
      case STATUS_ABSENT: return makeAppointmentStatusIcon(STATUS_ABSENT, 'Неявка');
      case STATUS_CAME: return makeAppointmentStatusIcon(STATUS_CAME, 'Пациент пришел');
      case STATUS_CONFIRM: return makeAppointmentStatusIcon(STATUS_CONFIRM, 'Запись подтверждена');
      case STATUS_PRODOCTOROV: return makeAppointmentStatusIcon(STATUS_PRODOCTOROV, 'Запись c продокторов');
      default: return createElement();
    }
  },
};

const LABEL_BLACK_LIST = 'black-list';
const LABEL_UNWANTED = 'unwanted';
const LABEL_VIP = 'vip';

/**
 * @description Компонент макета слота по умолчанию.
 * @type {Vue}
 */
const defaultLayout = {
  components: { appointmentStatus },
  functional: true,
  props: {
    ageTitle: { required: true, type: String },
    canCreateInvoice: { required: true, type: Boolean },
    interval: { required: true, type: String },
    isInitial: { required: true, type: Boolean },
    labels: { required: true, type: Array },
    patientName: { required: true, type: String },
    status: { default: '', type: String },
    invoiceStatus: { default: '', type: String },
    hasViewPatientInvoices: { default: () => false, type: Boolean },
    isArchived: { default: () => false, type: Boolean },
    cardNumber: { default: () => '', type: String },
    patientBirthDate: { default: '', type: String },
    date: { default: '', type: String },
  },
  name: 'TimetablePatientDefaultLayout',
  render(createElement, { listeners, props }) {
    const interval = createElement('span', { staticClass: 'timetable-patient-cell__time' }, props.interval);
    const patientName = createElement('span', { staticClass: 'timetable-patient-cell__name' }, [
      props.patientName,
      props.ageTitle && ' ',
      props.ageTitle && createElement('span', props.ageTitle),
      props.cardNumber && ' ',
      props.cardNumber && createElement('span', props.cardNumber),
    ]);
    const date = new Date(props.date);
    const birthDate = new Date(props.patientBirthDate);
    const isPatientBirthdayToday = birthDate.getDate() === date.getDate()
      && birthDate.getMonth() === date.getMonth();
    const makeChip = (text) => createElement(
      'span',
      {
        staticClass: 'timetable-patient-cell__chip',
        attrs: {
          title: 'Первичный прием',
        },
      },
      text,
    );

    const makeBirthDateIcon = () => createElement(
      'img',
      {
        staticClass: 'timetable-patient-cell__birthdate',
        attrs: {
          title: 'День рождения',
          alt: 'День рождения',
          src: new URL('../assets/img/birthday.svg', import.meta.url).href,
        },
      },
    );
    const makeArchiveIcon = () => createElement(
      'img',
      {
        staticClass: 'timetable-patient-cell__archive',
        attrs: {
          title: 'В архиве',
          alt: 'В архиве',
          src: new URL('../assets/img/archive-add-blue.svg', import.meta.url).href,
        },
      },
    );
    const makeInvoiceCreation = () => createElement(
      'button',
      {
        staticClass: 'timetable-patient-cell__invoice',
        on: listeners,
        attrs: {
          title: 'Создать счет и перейти к нему',
          type: 'button',
        },
      },
    );
    const makeInvoiceStatus = () => createElement(
      'div',
      {
        staticClass: `timetable-patient-cell__invoice ${props.invoiceStatus}`,
        on: { click: () => listeners['open-invoices']() },
        attrs: {
          title: 'Перейти к счетам',
          type: 'button',
        },
      },
    );
    const makeRow = (children) => createElement(
      'div',
      { staticClass: 'timetable-patient-cell__row' },
      children,
    );
    return [
      makeRow([
        patientName,
        props.isInitial && makeChip('1'),
        props.canCreateInvoice && makeInvoiceCreation(),
        props.patientBirthDate && isPatientBirthdayToday && makeBirthDateIcon(),
        (
          props.invoiceStatus
          && !props.canCreateInvoice
          && props.hasViewPatientInvoices
        )
        && makeInvoiceStatus(),
        props.isArchived && makeArchiveIcon(),
      ]),
      makeRow([
        interval,
        props.status && createElement(appointmentStatus, { props: { status: props.status } }),
      ]),
    ];
  },
};

/**
 * @description Название события создания счета.
 * @type {string}
 */
const NAME_EVENT_CREATE_INVOICE = 'create-invoice';

/**
 * @description Название события открытия счетов.
 * @type {string}
 */
const NAME_EVENT_OPEN_INVOICES = 'open-invoices';

/**
 * @description Название события инициации звонка.
 * @type {string}
 */
const NAME_EVENT_INITIATE_CALL = 'initiate-call';

/**
 * @description Высота единичного шага.
 * @type {number}
 */
const STEP_HEIGHT = 53;

export default {
  components: {
    TheTooltip, PopoverMenu, PatientLabels, defaultLayout,
  },
  mounted() {
    this.cellPopup = this.$refs.cellPopupRef;
  },
  computed: {
    /**
     * @description Возраст.
     * @type {string}
     */
    ageTitle() {
      if (this.expandedSlot === null) {
        return '';
      }
      return this.expandedSlot.ageTitle;
    },
    /**
     * @description Наличие расширенной информации.
     * @type {bool}
     */
    availableExpandedInfo() {
      if (this.canShowExpandedData === false) {
        return false;
      }
      const serviceNamesIsNotEmpty = this.expandedSlot.serviceNames.length;
      const patientPhoneIsNotEmpty = this.expandedSlot.patientPhone !== '';
      const noteIsNotEmpty = this.note !== '';
      return serviceNamesIsNotEmpty || patientPhoneIsNotEmpty || noteIsNotEmpty;
    },
    /**
     * @description Заголовок запрета соединения контакта.
     * @returns {string}
     */
    contactConnectRestrictTitle() {
      if (this.canInitiateCalls && this.noCalls) {
        return 'Пациент отказался от звонков';
      }
      if ((this.expandedSlot.hasWhatsApp || this.messengersAccess) && !this.agreeMailing) {
        return 'Пациент отказался от рассылок';
      }
      return '';
    },
    /**
     * @description Заголовок соединения контакта.
     * @returns {string}
     */
    contactConnectTitle() {
      if (this.canInitiateCalls) {
        return 'Начать звонок';
      }
      if (this.expandedSlot.hasWhatsApp || this.messengersAccess) {
        return 'Открыть чат';
      }
      return '';
    },
    /**
     * @description Количество возможных соединений по контакту пациента.
     * @returns {number}
     */
    countContactsConnect() {
      let count = 0;
      count += this.canInitiateCalls ? 1 : 0;
      count += this.expandedSlot.hasWhatsApp ? 1 : 0;
      count += this.messengersAccess ? 1 : 0;
      return count;
    },
    /**
     * @description Показывать медкарту пациента.
     * @type {bool}
     */
    showPatientCard() {
      return this.expandedSlot && this.expandedSlot.medcard !== '';
    },
    /**
     * @description Показать метки
     * @param expandedSlot
     * @return {boolean}
     */
    showLabels({ expandedSlot }) {
      return expandedSlot && !!expandedSlot.labelNames.length;
    },
    /**
     * @description Статус записи на прием.
     * @returns {string}
     */
    status({ tags }) {
      return [STATUS_ABSENT, STATUS_CAME, STATUS_CONFIRM, STATUS_PRODOCTOROV]
        .find((candidate) => tags.includes(candidate)) || '';
    },
    /**
     * @description Показывать расширенный попап.
     * @type {boolean}
     */
    canShowExpandedData() {
      return this.expandedSlot !== null && this.isDrag === false;
    },
    isOneRowLayout() {
      return this.tags.includes('one-row-layout');
    },
    isDefaultLayout() {
      return this.tags.includes('only-color-layout') === false;
    },
    /**
     * @description Список черт пациента.
     * @returns {string[]}
     */
    labels({ expandedSlot }) {
      if (expandedSlot === null) { return []; }
      return [LABEL_BLACK_LIST, LABEL_UNWANTED, LABEL_VIP]
        .filter((candidate) => expandedSlot.labelIds.includes(candidate));
    },
    /**
     * @description Заархивирован.
     * @param expandedSlot
     * @return {boolean}
     */
    archived({ expandedSlot }) {
      if (expandedSlot === null) { return false; }
      return expandedSlot.isArchived;
    },
    invoiceStatus() {
      if (this.hasDebt) {
        return 'debt';
      }
      if (this.hasAdvance) {
        return 'advance';
      }
      return '';
    },
    isDraggable() {
      return !this.tags.includes(STATUS_CAME);
    },
    /**
     * @description Обработанный цвет фона расширенного попапа.
     * @type {string}
     */
    processedColor() {
      return this.color || '#eaeff3';
    },
    /**
     * @description Вычисленное значение для высоты расширенного попапа.
     * @type {string}
     */
    processedHeight() {
      if (this.cellPopup) {
        const selfHeight = Math.floor(this.ratioStep) * STEP_HEIGHT;
        const cellPopupHeight = this.cellPopup.offsetHeight;
        if (selfHeight > cellPopupHeight) {
          return '100%';
        }
      }
      return '';
    },
  },
  data() {
    return {
      isDrag: false,
      cellPopup: null,
      isShowPhoneDialog: false,
    };
  },
  methods: {
    onClickContact() {
      if (this.canInitiateCalls) {
        this.onInitiateCall();
        return;
      }
      if (this.expandedSlot.hasWhatsApp) {
        this.onOpenWhatsAppChat();
        return;
      }
      this.onOpenMessengersChat();
    },
    /**
     * @description Обработать инициацию звонка.
     * @returns {void}
     */
    onInitiateCall() {
      this.isShowPhoneDialog = false;
      this.$emit(NAME_EVENT_INITIATE_CALL, this.appointmentId);
    },
    /**
     * @description Обработать открытие чата Whats App.
     * @returns {void}
     */
    onOpenWhatsAppChat() {
      const phoneWithoutDelimiters = this.expandedSlot.patientPhone.replace(/[-+() ]/g, '');
      this.isShowPhoneDialog = false;
      EventBus.$emit(NAME_EVENT_OPEN_WHATS_APP_CHAT, phoneWithoutDelimiters);
    },
    /**
     * @description Обработать открытие чата в мессенджере.
     * @returns {void}
     */
    onOpenMessengersChat() {
      const phoneWithoutDelimiters = this.expandedSlot.patientPhone.replace(/[-+() ]/g, '');
      this.isShowPhoneDialog = false;
      EventBus.$emit(NAME_EVENT_OPEN_MESSENGERS_CHAT, phoneWithoutDelimiters);
    },
    /**
     * @description Обработать создание счета.
     * @returns {void}
     */
    onCreateInvoice() {
      this.$emit(NAME_EVENT_CREATE_INVOICE);
    },
    onDragEnd(ev) {
      this.isDrag = false;
      this.$emit('dragend', ev);
    },
    /**
     * @description Обработать начало перетаскивания.
     * @param {DragEvent} ev
     * @returns {void}
     */
    onDragStart(ev) {
      Object.assign(ev.dataTransfer, {
        ...ev.dataTransfer,
        effectAllowed: 'move',
        dropEffect: 'move',
      });
      ev.dataTransfer.setData('appointment-id', this.appointmentId);
      ev.dataTransfer.setData('ratio-step', this.ratioStep);
      this.$emit('dragstart', ev);
      setTimeout(() => { this.isDrag = true; }, 0);
    },
    /**
     * @description Обработать открытие счетов.
     * @returns {void}
     */
    onOpenInvoices() {
      this.$emit(NAME_EVENT_OPEN_INVOICES);
    },
    /**
     * @description Отправить событие клика.
     */
    dispatchClick() {
      this.$emit('click');
    },
  },
  props: {
    /**
     * @description Можно создать счет.
     * @type {boolean}
     */
    canCreateInvoice: { default: () => false, type: Boolean },
    /**
     * @description Может инициировать звонки.
     */
    canInitiateCalls: { default: () => false, type: Boolean },
    /**
     * @description Идентификатор записи на прием.
     * @type {number}
     */
    appointmentId: { required: true, type: Number },
    /**
     * @description Цвет заднего фона.
     * @type {string}
     */
    color: { type: String, default: '#eaeff3' },
    /**
     * @description Расширенный слот.
     * @type {any}
     */
    expandedSlot: { default: null, type: Object },
    /**
     * @description Размер относительно шага.
     * @type {Number}
     */
    ratioStep: { required: true, type: Number },
    /**
     * @description Интервал приема.
     * @type {string}
     */
    interval: { required: true, type: String },
    /**
     * @description Первичный прием.
     * @type {boolean}
     */
    isInitial: Boolean,
    /**
     * @description Примечание.
     * @type {string}
     */
    note: { type: String, default: '' },
    /**
     * @description Полное имя пацеинта.
     * @type {string}
     */
    patientFullName: { required: true, type: String },
    /**
     * @description Имя пациента.
     * @type {string}
     */
    patientName: { required: true, type: String },
    /**
     * @description Тэги.
     * @type {string[]}
     */
    tags: { required: true, type: Array },
    /**
     * @description Показывать имя сотрудника.
     * @type {boolean}
     */
    showEmployeeName: { type: Boolean, default: false },
    hasDebt: { type: Boolean, default: false },
    hasAdvance: { type: Boolean, default: false },
    noCalls: { type: Boolean, default: false },
    agreeMailing: { type: Boolean, default: true },
    /**
     * @description Может просматривать счета пациентов.
     * @type {boolean}
     */
    hasViewPatientInvoices: { type: Boolean, default: false },
    /**
     * @description Номер мед. карты пациента.
     * @type {String}
     */
    patientCardNumber: { type: String, default: () => '' },
    /**
     * @description Дата рождения пацеинта.
     * @type {string}
     */
    patientBirthDate: { type: String, default: '' },
    /**
     * @description Дата в формате ISO.
     * @type {string}
     */
    date: { type: String, default: '' },
    /**
     * @description Доступ к мессенджерам.
     * @type {string}
     */
    messengersAccess: { type: Boolean, default: false },
  },
  name: 'TimetablePatientCell',
};
</script>

<style scoped lang="scss">

@keyframes fadeInOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}

::v-global(.timetable-cell-modal-contacts) {
  border: 1px solid var(--action-color);
}
.timetable-cell-modal-contacts {
  &__content {
    display: grid;
  }
  &__button {
    display: flex;
    align-items: center;
    column-gap: 10px;
    padding: 10px;
    transition: color 0.3s ease;
    &::before {
      content: '';
      width: 20px;
      height: 20px;
      background: no-repeat 50%;
      background-size: contain;
    }
    &.phone::before {
      background-image: url('@/assets/img/phone-blue.svg');
    }
    &.whatsapp::before {
      background-image: url('@/assets/img/social/whatsapp-brand-green.svg');
    }
    &.chat-push::before {
      background-image: url('@/assets/img/chat.svg');
    }
    &:not(:last-child) {
      border-bottom: 1px solid var(--action-color);
    }
    &:not(:disabled):hover {
      color: var(--action-color);
    }
  }
}

.timetable-patient-cell {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  gap: 4px;
  padding: 2px 6px;
  height: 100%;
  &.ignore {
    pointer-events: none;
    .timetable-patient-cell__status {
      pointer-events: none;
    }
  }
  &__row {
    pointer-events: none;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    flex-wrap: nowrap;
    gap: 8px;
    width: 100%;
    justify-content: space-between;
  }
  &__text,
  &__name {
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    color: #192a3e;
    max-width: 150px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  &__chip {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 12px;
    font-weight: 400;
    font-size: 12px;
    line-height: 12px;
    padding: 2px 5px;
    color: #323c47;
    pointer-events: auto;
    cursor: help;
  }
  &__labels {
    display: flex;
    flex: 1;
    margin-left: 7px;
    gap: 5px;
    & > * {
      stroke: gold;
    }
  }
  &__label {
    &.black-list {
      pointer-events: all;
      background-image: url('@/assets/img/black-list-grey.svg');
      background-position: center;
      width: 16px;
      height: 24px;
    }
    &.unwanted {
      pointer-events: all;
      background-image: url('@/assets/img/mad-grey.svg');
      background-position: center;
      width: 16px;
      height: 24px;
    }
  }
  &__time {
    color: #192a3e;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    white-space: nowrap;
  }
  &__status {
    align-self: flex-end;
    width: 20px;
    height: 15px;
    color: #192a3e;
    font-weight: 400;
    font-size: 12px;
    line-height: 14px;
    pointer-events: all;
    background-repeat: no-repeat;
    background-position: center;
    & > img {
      pointer-events: none;
    }
    &.absent {
      background-image: url('@/assets/img/status/absence-black.svg');
    }
    &.came {
      background-image: url('@/assets/img/checked/all-checked-dark-top.svg');
    }
    &.confirm {
      background-image: url('@/assets/img/checked/checked-dark-top.svg');
    }
    &.prodoctorov {
      background-image: url('@/assets/img/globe.svg');
      background-size: 18px 18px;
    }
  }
  &__archive {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    object-fit: contain;
    pointer-events: auto;
  }
  &__invoice {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    pointer-events: all;
    background-image: url("@/assets/img/switch/tenge-grey.svg");
    background-position: center;
    background-size: contain;
    &:hover {
      background-image: url("@/assets/img/switch/tenge-blue.svg");
    }
    &.debt {
      background-image: url("@/assets/img/switch/tenge-red.svg");
    }
    &.advance {
      background-image: url("@/assets/img/switch/tenge-green.svg");
    }
  }
  &__birthdate {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    pointer-events: all;
  }
  &:hover {
    border-end-end-radius: 0;
    border-end-start-radius: 0;
    .timetable-patient-cell__hover {
      visibility: visible;
      opacity: 1;
      animation-name: fadeInOpacity;
      animation-iteration-count: 1;
      animation-timing-function: ease-in;
      animation-duration: 250ms;
    }
  }
  &__hover {
    visibility: hidden;
    opacity: 0;
    position: absolute;
    top: -1px;
    left: 0;
    z-index: 1;
    width: 100%;
    border-end-end-radius: var(--block-border-radius);
    border-end-start-radius: var(--block-border-radius);
    padding: 6px;
    box-shadow: 0 14px 28px rgba(0,0,0,0.25), 0 10px 10px rgba(0,0,0,0.22);
    & .timetable-patient-cell__name {
      white-space: normal;
    }
  }
  &__info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    padding: 8px 0;
    &.employee {
      gap: 2px;
    }
    &__note,
    &__text {
      color: var(--reading-color);
      font-size: 12px;
      font-weight: 600;
      line-height: 17px;
      &.callable {
        text-align: left;
        color: var(--action-color);
        text-decoration: underline;
      }
    }
    &__note {
      font-weight: 400;
      overflow-wrap: anywhere;
      opacity: 0.7;
    }
  }
}
</style>
